/**
 * @file withViewComponent 包装编译生成的组件
 * @author Yu Zong(liuxuanzy@qq.com)
 */
import { useCallback } from 'react';
import { pascalCase } from '@tencent/glue-util-helper';
import { useConfig } from '../context/config';
import { getPrefixCls } from '../hooks/usePrefix';
export function withViewComponent(component, name, keys) {
  function Component(props) {
    var style = props.style,
        className = props.className;
    var attrs = {};
    var rest = {};
    keys.forEach(function (key) {
      if (key in props) {
        attrs[key] = props[key];
      }
    });
    Object.keys(props).forEach(function (key) {
      if (key === 'style' || key === 'className' || key in attrs) {
        return;
      }

      rest[key] = props[key];
    });

    var _useConfig = useConfig(),
        prefix = _useConfig.prefix;

    var combine = useCallback(function (hasRoot, suffixClass, hasRest, bind) {
      var main = "".concat(prefix, "-").concat(name).concat(typeof hasRoot === 'string' ? "-".concat(hasRoot) : '');
      var classNames = [];

      if (hasRoot) {
        classNames.push(main);
      }

      classNames.push(getPrefixCls(main, suffixClass, !!hasRoot));

      if (bind) {
        classNames.push(bind);
      }

      if (hasRest && className) {
        classNames.push(className);
      }

      return classNames.join(' ');
    }, [prefix, className]);
    return component(attrs, style, combine, rest);
  }

  Component.displayName = pascalCase("view-".concat(name));
  return Component;
}